module.exports = __webpack_public_path__ + "static/media/edit-document.97aa25de.svg";